import React, { useState, useEffect } from "react";
import overlayFactory from "react-bootstrap-table2-overlay";
import BootstrapTable from "react-bootstrap-table-next";

import "react-awesome-lightbox/build/style.css";
import { Card, Container, Row, Col, Spinner } from "react-bootstrap";

import MultiSelect from "react-multi-select-component";
import Select from "react-select";

import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";

/* Styles */
import "../../../../../../styles/app/pages/CampaingPreview.scss";
const addCommas = function (input) {
    // If the regex doesn't match, `replace` returns the string unmodified
    return (input.toString()).replace(
        // Each parentheses group (or 'capture') in this regex becomes an argument 
        // to the function; in this case, every argument after 'match'
        /^([-+]?)(0?)(\d+)(.?)(\d+)$/g, function (match, sign, zeros, before, decimal, after) {

            // Less obtrusive than adding 'reverse' method on all strings
            var reverseString = function (string) { return string.split('').reverse().join(''); };

            // Insert commas every three characters from the right
            var insertCommas = function (string) {

                // Reverse, because it's easier to do things from the left
                var reversed = reverseString(string);

                // Add commas every three characters
                var reversedWithCommas = reversed.match(/.{1,3}/g).join(',');

                // Reverse again (back to normal)
                return reverseString(reversedWithCommas);
            };

            // If there was no decimal, the last capture grabs the final digit, so
            // we have to put it back together with the 'before' substring
            return sign + (decimal ? insertCommas(before) + decimal + after : insertCommas(before + after));
        }
    );
};
export function priceFormatter(column) {
    return (
        <h6><strong>{Number((column.footer || 0).toFixed(2))}%</strong></h6>
    );
}
export function unitsFormatter(column) {
    return (
        <h6><strong>{addCommas(Number(column.footer ?? 0).toFixed(0))}</strong></h6>
    );
}
export const Report4 = ({ props }) => {
    const _rows = props.rows.sort((a, b) => a.no - b.no);
    const [mainTask, setMainTask] = useState({});

    const pos_map = _rows.map((key) => key.pos);
    const pos_unique = [...new Set(pos_map)];
    const pos_options = pos_unique
        .sort((a, b) => {
            if (a.label < b.label) { return -1 }
            if (a.label > b.label) { return 1 }
            return 0
        })
        .map((key) => ({ label: key, value: key }));
    const [pos_selected, pos_setSelected] = useState([]);

    const round_map = _rows.map((key) => key.round);
    const round_unique = [...new Set(round_map)];
    const round_options = round_unique.map((key) => ({ label: key, value: key }));
    const [round_selected, round_setSelected] = useState([]);

    const product_map = _rows.map((key) => key.product);
    const product_unique = [...new Set(product_map)];
    const product_options = product_unique
        .filter(key => Boolean(key))
        .map((key) => ({
            label: key,
            value: key,
        }));
    const [products_selected, products_setSelected] = useState([]);

    const [agent_selected, agent_setSelected] = useState([]);

    const task_map = _rows.map((key) => key.task);
    const task_unique = [...new Set(task_map)];
    const task_options = task_unique.map((key) => ({ label: key, value: key }))
        .sort((a, b) => {
            if (a.label < b.label) { return -1 }
            if (a.label > b.label) { return 1 }
            return 0
        })

    useEffect(() => {
        const pos_map = _rows.map((key) => key.pos);
        const pos_unique = [...new Set(pos_map)];
        const pos_options = pos_unique.map((key) => ({ label: key, value: key }));
        pos_setSelected(pos_options.sort((a, b) => {
            if (a.label < b.label) { return -1 }
            if (a.label > b.label) { return 1 }
            return 0
        }));
        const round_map = _rows.map((key) => key.round);
        const round_unique = [...new Set(round_map)];
        const round_options = round_unique.map((key) => ({
            label: key,
            value: key,
        }));
        round_setSelected(round_options);
        const product_map = _rows.map((key) => key.product);
        const product_unique = [...new Set(product_map)];
        const product_options = product_unique.map((key) => ({
            label: key,
            value: key,
        }));
        products_setSelected(product_options)
        const agent_map = _rows.map((key) => key.agent);
        const agent_unique = [...new Set(agent_map)];
        const agent_options = agent_unique.map((key) => ({
            label: key,
            value: key,
        }));
        agent_setSelected(agent_options);
        const task_map = props.tasks.map((key) => key.name);

        const task_unique = [...new Set(task_map)];
        const task_options = task_unique.map((key) => ({ label: key, value: key }));
        const [default_task] = task_options;
        default_task && setMainTask(default_task);
    }, [_rows, props.tasks]);

    const raw = _rows
        .filter((row) => row.yesno === "YES" || row.yesno === "NO")
        .filter((row) => row.task === mainTask.value)
        .filter((row) => pos_selected.map((row) => row.value).includes(row.pos))
        .filter((row) => round_selected.map((row) => row.value).includes(row.round))
        .filter((row) => agent_selected.map((row) => row.value).includes(row.agent))
        .filter((row) => products_selected.map((row) => row.value).includes(row.product));

    const body = []

    pos_options.forEach((pos) => {
        const results = [...raw].filter(row => row.pos === pos.value)
        const yes = results.filter(row => row.yesno === "YES")
        const no = results.filter(row => row.yesno === "NO")
        const percent_no = Number(((no.length / results.length) * 100).toFixed(2))
        const percent_yes = Number(((yes.length / results.length) * 100).toFixed(2))

        const document = {
            pos: pos.value,
            no: no.length,
            yes: yes.length,
            total: results.length,
            percent_no: Number(percent_no.toFixed(2)) + "%",
            percent_yes: Number(percent_yes.toFixed(2)) + "%"

        }
        body.push(document)

    })
    const _percent_no = body.reduce((tl, row) => {
        const [n] = row.percent_no.split("%")
        if (isNaN((Number(n)))) { return tl }
        return tl + Number(n)
    }, 0) / pos_options.length

    const _percent_yes = body.reduce((tl, row) => {
        const [n] = row.percent_yes.split("%")
        if (isNaN((Number(n)))) {
            return tl
        }
        return tl + Number(n)
    }, 0) / pos_options.length
    const _cols = [
        {
            dataField: "pos",
            text: "Location",
            sort: true,
        },
        {
            dataField: "no",
            text: "no",
            sort: true,
            headerStyle: {
                width: "70px",
            }
        },
        {
            dataField: "yes",
            text: "yes",
            sort: true,
            headerStyle: {
                width: "70px",
            }
        },
        {
            dataField: "total",
            text: "answers",
            sort: true,
            headerStyle: {
                width: "110px",
            }
        },
        {
            dataField: "percent_no",
            text: "No %",
            sort: true,
            footer: _percent_no,
            headerStyle: {
                width: "80px",
            }
        },
        {
            dataField: "percent_yes",
            text: "yes %",
            sort: true,
            footer: _percent_yes,
            headerStyle: {
                width: "80px",
            }   

        },
    ]
    const totalizer_cols = ["no", "yes", "total", "percent_no", "percent_yes"]
    const money_cols = ["percent_no", "percent_yes"]
    const cols = _cols.map(col => {
        if (!totalizer_cols.includes(col.dataField)) {
            return { ...col, footer: "Total" }
        }
        const total = body.reduce((acc, row) => acc + Number(row[col.dataField] ?? 1), 0)
        return {
            ...col,
            footer: col.footer ?? total,
            footerFormatter: money_cols.includes(col.dataField) ?
                priceFormatter : unitsFormatter
        }

    })
    return (
        <Card.Body className="p-4 mt-5">
            <Container fluid>
                <Row className="w-100 justify-content-end"></Row>
                <br />
                <Row>
                    <Col>
                        <label>Select POS</label>
                        <MultiSelect
                            name="pos"
                            options={pos_options}
                            value={pos_selected}
                            onChange={pos_setSelected}
                            labelledBy={"Select POS"}
                        />
                    </Col>
                    <Col>
                        <label>Select Rounds</label>
                        <MultiSelect
                            name="round"
                            options={round_options}
                            value={round_selected}
                            onChange={round_setSelected}
                            labelledBy={"Select Round"}
                        />
                    </Col>
                    <Col>
                        <label>Select Products</label>
                        <MultiSelect
                            name="products"
                            value={products_selected}
                            options={product_options}
                            onChange={products_setSelected}
                            labelledBy={"Select Products"}

                        />
                    </Col>
                    <Col xs={3}>
                        <label>Select Tasks</label>
                        <Select
                            defaultValue={task_options[0]}
                            options={task_options}
                            onChange={setMainTask}
                        />
                    </Col>
                </Row>
                <br />

                {!props.queryng ? (
                    <>
                        <Col xs={12}>
                            <Card className="p-2 mb-2">
                                <Card.Body>
                                    <span className="text-muted h4 mb-3">Task: </span><span className="h2"><strong>{mainTask.label}</strong></span>
                                    <br />
                                    <div style={{ height: "500px", overflowY: "scroll", overflowX: "hidden"}}>

                                    <BootstrapTable
                                        wrapperClasses="table-responsive"
                                        bordered={false}
                                        classes="table table-head-custom table-vertical-center"
                                        bootstrap4
                                        hover
                                        striped
                                        keyField="uid"
                                        loading={props.queryng}
                                        overlay={overlayFactory({ spinner: true })}
                                        noDataIndication={
                                            <div className="mr-2 text-muted">No records found</div>
                                        }
                                        data={body.map((doc, i) => ({
                                            count: Number(i) + 1,
                                            ...doc,
                                        }))}
                                        columns={cols}
                                    ></BootstrapTable>

</div>




                                </Card.Body>
                            </Card>
                        </Col>

                    </>
                ) : (
                    <div className="mt-2 w-100 d-flex justify-content-center">
                        <Spinner animation="border" role="status">
                            <span className="sr-only">Loading...</span>
                        </Spinner>
                    </div>
                )}
            </Container>
        </Card.Body>
    );
};

